import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

// Super Admin: the barangay currently selected in System Settings / Central LGU administration.
export function setAdminTenant(id) {
  if (id) api.defaults.headers.common["X-Admin-Tenant"] = id;
  else delete api.defaults.headers.common["X-Admin-Tenant"];
}

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).startsWith("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        window.dispatchEvent(new Event("bims:logout"));
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "Service unavailable. Check your connection and try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return "Something went wrong. Please try again.";
}

export const assetUrl = (p) => (p ? `${BACKEND}${p}` : null);

export async function downloadBlob(url, filename) {
  let res;
  try {
    res = await api.get(url, { responseType: "blob" });
  } catch (e) {
    const b = e?.response?.data;
    if (b instanceof Blob) {
      try { e.response.data = JSON.parse(await b.text()); } catch { /* keep original */ }
    }
    throw e;
  }
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}

export const newIdemKey = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + Math.random());
